module.exports = __webpack_public_path__ + "static/media/Schritt_3_Gespraech_mit_dem_Arzt.587f7907.pdf";